module.exports = __webpack_public_path__ + "static/media/G1246957_Japan-34.133fe1e9.png";